'use strict';
const angular = require('angular');
import { saveAs } from 'file-saver';
const anchorme = require("anchorme").default;
const { anonProfileImage, adminProfile } = require('./groups.profiles');

/*@ngInject*/
export function groupsService(Util, Auth, common, $http, $timeout, socket, $sce, $interval) {
  var safeCb = Util.safeCb;
  var groups = [];
  var myGroup = {};
  var unassignedUsers = [];
  var initialised = false;
  var myInitialised = false;
  var groupMessages = [];
  var topTopic = 0;
  var creatingGroup = false;
  var postingMessage = false;
  var currentGroup = '';
  var canIPost = true;
  var singleStream = false;
  var inTopicPosting = false;
  var currentUserId = '';
  var isAdmin = Auth.isAdminSync;
  var currentGroupId = '';
  var videoLink = '';
  var globalSettings = {
    postingAllowed: true
  };
  var globalSettingsInitialised = false;

  return {
    initialise(callbackSuccess, callbackError) {
      var that = this;
      common.setLoading(true);
      if(!initialised) {
        var promise = $http.get('/api/groups/');
        promise.then(response => {
          try {
            groups = response.data.groups;
            unassignedUsers = response.data.users;
            groups.unshift({
              _id: 'unassignedUsers',
              _users: unassignedUsers,
              active: true
            });
            common.setQuickNotification('groups loaded', 'success');
            initialised = true;
            safeCb(callbackSuccess)(response.data);
          } catch(e) {
            console.log(e);
            common.setQuickNotification('Error loading groups', 'danger');
            safeCb(callbackError)(err);
          }
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error getting groups. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
          }
          if (err.status == 404) {
            common.setQuickNotification('No groups found', 'danger');
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
        });
      } else {
        safeCb(callbackSuccess)(groups);
      }
    },

    myInitialise(groupId, user, callbackSuccess, callbackError) {
      var that = this;
      common.setLoading(true);
      currentUserId = user;
      if(!myInitialised || groupId !== currentGroupId ) {
        currentGroupId = groupId;
        var promise = $http.get(`/api/groups/me/${groupId}`);
        promise.then(response => {
          try {
            myGroup = response.data;
            videoLink = myGroup.introVideo;
            var promiseTwo = $http.get(`/api/messages/group/${groupId}`);
            promiseTwo.then(restwo => {
              try {
                groupMessages = restwo.data.msgs;
                socket.syncUpdates('message', groupMessages, function(e, msg, newGroupArray) {
                  if(e == 'created') {
                    console.log('All Users', myGroup._users);
                    for(var u = 0; u < myGroup._users.length; u++) {
                      if(msg._user == myGroup._users[u]._id) {
                        console.log('Setting User As', myGroup._users[u]);
                        msg._user = myGroup._users[u];
                        break;
                      }
                    }
                    if(msg.isAdminPost) {
                      msg._user = adminProfile;
                    } else if(myGroup.anonymiseIcons) {
                      if(typeof msg._user === 'object') {
                        msg._user.pseudoname = 'A.N.Other';
                        msg._user.profileimage = anonProfileImage;
                      } else {
                        let userObj = {
                          _id: msg._user,
                          pseudoname: 'A.N.Other',
                          profileimage: anonProfileImage
                        };
                        msg._user = userObj;
                      }
                    }
                    if(!msg._user.pseudoname) {
                      // check user against me
                      msg._user = Auth.getCurrentUserSync();
                    }
                    if(msg._group == myGroup._id) {
                      msg.topicNumber = topTopic;
                      that.setLinkage(msg);
                      groupMessages.push(msg);
                    }
                  }
                });
                canIPost = restwo.data.canIPost;
                console.log('Is SingleStream:', restwo.data.singleStream);
                singleStream = restwo.data.singleStream;
                console.log('local SingleStream:', singleStream);
                inTopicPosting = restwo.data.inTopicPosting;
                that.topicifyMessages();
                common.setQuickNotification('Your group loaded', 'success');
                myInitialised = true;
                safeCb(callbackSuccess)(response.data);
              } catch(e) {
                console.log(e);
                common.setQuickNotification('Error loading your messages', 'danger');
                safeCb(callbackError)(err);
              }
            }).catch(err => {
              if(err.status != 401 && err.status != 404) {
                common.setAlert('Error', 'danger', `Error getting your messages. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
              }
              if (err.status == 404) {
                common.setQuickNotification('No messages found', 'danger');
              }
              if(callbackError) {
                safeCb(callbackError)(err.data);
              } else if(callbackSuccess) {
                safeCb(callbackSuccess)(err.data);
              }
            });
          } catch(e) {
            console.log(e);
            common.setQuickNotification('Error loading your group', 'danger');
            safeCb(callbackError)(err);
          }
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error getting your group. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
          }
          if (err.status == 404) {
            common.setQuickNotification('No group found', 'danger');
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
        });
      } else {
        safeCb(callbackSuccess)(groups);
      }
    },

    initialiseGlobals(callbackSuccess, callbackError) {
      console.log('Initialising Global Settings', isAdmin);
      if(!isAdmin) {
        console.log('Not an admin, not initialising global settings');
        return; // only admins can change global settings
      }
      var promise = $http.get('/api/groups/globals');
      promise.then(response => {
        try {
          globalSettings.postingAllowed = response.data.postingAllowed;
          globalSettingsInitialised = true;
          $interval(function() {
            var gp = $http.get('/api/groups/globals');
            gp.then(gres => {
              globalSettings.postingAllowed = gres.data.postingAllowed;
            }).catch(err => {
              if(err.status != 401 && err.status != 404) {
                common.setAlert('Error', 'danger', `Error getting global settings. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
              }
            });
          }, 60000);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
          common.setQuickNotification('Error loading global settings', 'danger');
          safeCb(callbackError)(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error getting global settings. Please try again. (Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(err.status == 404) {
          common.setQuickNotification('No global settings found', 'danger');
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    },

    clearAllData() {
      groups = [];
      myGroup = {};
      unassignedUsers = [];
      initialised = false;
      myInitialised = false;
      groupMessages = [];
      topTopic = 0;
      creatingGroup = false;
      postingMessage = false;
      currentGroup = '';
      canIPost = true;
      singleStream = false;
      inTopicPosting = false;
      currentUserId = '';
      currentGroupId = '';
    },

    topicPosting() {
      if (!globalSettings.postingAllowed) return false;
      if(singleStream) return true;
      return inTopicPosting;
    },

    postable() {
      if (!globalSettings.postingAllowed) return false;
      return true;
      //if(singleStream) return true;
      //return canIPost;
    },

    getGlobalSettings() {
      if(!globalSettingsInitialised) {
        this.initialiseGlobals(function() {}, function() {});
      }
      return globalSettings;
    },

    getVideoLink() {
      return videoLink;
    },

    singleStream() {
      return singleStream;
    },

    getUnassignedUsers() {
      return unassignedUsers;
    },

    getMyGroup() {
      return myGroup;
    },

    getGroups() {
      // Sort Users
      if(groups.length > 0) {
        let ug = groups[0]; // unassignedGroup
        ug._users.sort(function(a, b) {
          return (a.name > b.name) ? 1 : -1;
        });
      }
      return groups;
    },

    getMessages() {
      return groupMessages;
    },

    getTopTopic() {
      return topTopic;
    },

    topicifyMessages() {
      var topicSeed = 0;
      var gotAReply = false;
      if (groupMessages.length > 0){
        groupMessages[0].topicNumber = topicSeed;
        for (var gm=1; gm<groupMessages.length; gm++){
          if (!groupMessages[gm].isAdminPost) {
            gotAReply = true;
          } else {
            if (gotAReply) {
              topicSeed = topicSeed + 1;
              gotAReply = false;
            }
          }
          groupMessages[gm].topicNumber = topicSeed;
          this.countReactions(groupMessages[gm]);
          this.setLinkage(groupMessages[gm]);
        }
      }      
      topTopic = topicSeed;
    },

    setLinkage(msg) {
      msg.textOnly = msg.msg;
      msg.msg = $sce.trustAsHtml(anchorme({
        input: msg.msg,
        options: {
          attributes: {
              target: "_blank"
          },
        }
      }));
    },

    countReactions(message) {
      var myReaction = '';
      var thumbsup = 0;
      var thumbsdown = 0;
      var pondering = 0;
      for (var r=0; r<message.reactions.length; r++){
        if (message.reactions[r]._user.toString() == currentUserId.toString()){
          myReaction = message.reactions[r].reaction;
        } else {
        }
        switch (message.reactions[r].reaction) {
          case 'thumbsup':
            thumbsup++;
            break;
          case 'thumbsdown':
            thumbsdown++;
            break;
          case 'pondering':
            pondering++;
            break;
        }
      }
      message.thumbsup = thumbsup;
      message.thumbsdown = thumbsdown;
      message.pondering = pondering;
      message.myreaction = myReaction;
    },

    saveFileAs(fileName) {
      window.open(`/PDFs/${fileName}`, "_blank");
    },

    printPdf(changedList, callbackSuccess, callbackError) {      
      var promise = $http.post('/api/groups/createpasswordpdf', changedList);
      promise.then(response => {
        try {
          this.saveFileAs(response.data);
          $timeout(function() {
            common.setQuickNotification('PDF created.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
        creatingGroup = false;
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error creating PDF.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
        creatingGroup = false;
      });
    },

    printTopicPdf(currentTopic, callbackSuccess, callbackError) {
      var topicMessages = [];
      for (var gm=0; gm<groupMessages.length; gm++) {
        if (groupMessages[gm].topicNumber == currentTopic) {
          topicMessages.push(groupMessages[gm]);
        }
      }
      var rightNow = (new Date()).toISOString().substring(0, 19).replace(/T/g, "-").replace(/:/g, "");
      var topicId = topicMessages[0]._id;
      var filename = `topicPdf_${rightNow}_${topicId}.pdf`;
      topicMessages[0].filename = filename;

      var promise = $http.post('/api/messages/createpdf', topicMessages);
      promise.then(response => {
        try {
          this.saveFileAs(response.data);
          $timeout(function() {
            common.setQuickNotification('PDF created.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
        creatingGroup = false;
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error creating PDF.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
        creatingGroup = false;
      });
    },

    setCurrentGroup(id) {
      currentGroup = id;
    },

    getCurrentGroup() {
      return currentGroup;
    },

    removeUserFromGroup(userId, groupId, callbackSuccess, callbackError) {
      common.setQuickNotification('Updating Group...', 'info');
      // add user to unassigned
      var gIndex = groups.map(function(gp){ return gp._id; }).indexOf(groupId);
      var uIndex = groups[gIndex]._users.map(function(usr){ return usr._id; }).indexOf(userId);
      groups[gIndex].userId = groups[gIndex]._users[uIndex]._id;
      unassignedUsers.push(groups[gIndex]._users[uIndex]);
      groups[gIndex]._users.splice(uIndex, 1);
      var promise = $http.put(`/api/groups/remove/${groupId}`, groups[gIndex]);
      promise.then(response => {
        try {
          if (groups[gIndex]._users.length <= 0) {
            groups.splice(gIndex, 1);
          }
          $timeout(function() {
            common.setQuickNotification('Group updated.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error upating Group.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    },

    createNewGroup(newGroup, callbackSuccess, callbackError) {
      if(!creatingGroup) {
        creatingGroup = true;
        common.setQuickNotification('Creating Group...', 'info');
        const d = new Date();
        //newGroup.name = 'Group ' + d.toLocaleString();
        var promise = $http.post('/api/groups', newGroup);
        promise.then(response => {
          try {
            groups.push(response.data);
            $timeout(function() {
              common.setQuickNotification('Group created.', 'success');
            }, 400);
            // remove new grouped users from unassigned
            for (var u=0; u<newGroup._users.length; u++) {
              var mpd = unassignedUsers.map(function(user){ return user._id; });
              var uIndex = mpd.indexOf(newGroup._users[u]);
              if (uIndex > -1) {
                unassignedUsers.splice(uIndex, 1);
              }
            }
            safeCb(callbackSuccess)(response.data);
          } catch(e) {
            console.log(e);
          }
          creatingGroup = false;
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error creating Group.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
          creatingGroup = false;
        });
      } else {
        common.setQuickNotification('Group being created please wait...', 'info');
      }
    },

    saveGroupUpdate(id, callbackSuccess, callbackError) {
      common.setQuickNotification('Saving Group...', 'info');
      var thisGroup = this.findGroupById(id);
      Reflect.deleteProperty(thisGroup, '__v');
      if(!thisGroup.anonymiseIcons) thisGroup.anonymiseIcons = false;
      if(!thisGroup.singleStream) thisGroup.singleStream = false;
      var promise = $http.put(`/api/groups/${id}`, thisGroup);
      promise.then(response => {
        try {
          $timeout(function() {
            common.setQuickNotification('Group Saved.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error saving Group.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    },

    addPersonToGroup(groupId, userId, callbackSuccess, callbackError) {
      if (!creatingGroup) {
        creatingGroup = true;
        common.setQuickNotification('Adding to Group...', 'info');
        var promise = $http.post('/api/groups/add', { group: groupId, user: userId });
        promise.then(response => {
          try {
            $timeout(function() {
              common.setQuickNotification('Added to Group.', 'success');
            }, 400);
            // remove user from unassigned.
            var gIndex = groups.map(function(gp){ return gp._id; }).indexOf(groupId);
            var uIndex = groups[0]._users.map(function(us){ return us._id }).indexOf(userId);
            groups[gIndex]._users.push(groups[0]._users[uIndex]);
            groups[0]._users.splice(uIndex, 1);
            safeCb(callbackSuccess)(response.data);
          } catch(e) {
            console.log(e);
          }
          creatingGroup = false;
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error adding to group.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
          creatingGroup = false;
        });
      } else {
        common.setQuickNotification('Person being added to group please wait...', 'info');
      }
    },

    findGroupById(id) {
      var gIndex = groups.map(function(gp) {
        return gp._id;
      }).indexOf(id);
      return groups[gIndex];
    },

    findMessageById(id) {
      var mIndex = groupMessages.map(function(msg) {
        return msg._id;
      }).indexOf(id);
      return groupMessages[mIndex];
    },

    postNewMessage(message, replyingTo, replyingMessage, messageFile, isAdmin, callbackSuccess, callbackError) {
      var that = this;
      if (!postingMessage) {
        postingMessage = true;
        common.setQuickNotification('Posting message...', 'info');
        var groupId = myGroup._id;
        if (currentGroup !== '') groupId = currentGroup;
        currentGroup = '';
        var promise = $http.post('/api/messages', {
          msg: message.trim(),
          _group: groupId,
          isAdminPost: isAdmin,
          imageAttached: messageFile,
          _reply: { msgId: replyingTo, msgText: replyingMessage }
        });
        promise.then(response => {
          try {
            $timeout(function() {
              common.setQuickNotification('Message posted.', 'success');
            }, 400);
            safeCb(callbackSuccess)(response.data);
          } catch(e) {
            console.log(e);
          }
          if (that.postable() && that.topicPosting() && !that.singleStream) {
            canIPost = false;
          } else {
            canIPost = true;
          }
          postingMessage = false;
        }).catch(err => {
          if(err.status != 401 && err.status != 404) {
            common.setAlert('Error', 'danger', `Error posting message.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
          }
          if(callbackError) {
            safeCb(callbackError)(err.data);
          } else if(callbackSuccess) {
            safeCb(callbackSuccess)(err.data);
          }
          postingMessage = false;
        });
      } else {
        common.setQuickNotification('Message being posted please wait...', 'info');
      }
    },

    addReactionToMessage(reaction, user, message, callbackSuccess, callbackError) {
      var thisMessage = this.findMessageById(message);
      if (typeof thisMessage.reactions != 'undefined') {
        var uIndex = thisMessage.reactions.map(function(rctn){ return rctn._user}).indexOf(user);
      } else {
        thisMessage.reactions = [];
        var uIndex = -1;
      }
      if (uIndex < 0) {
        thisMessage.reactions.push({ _user: user, reaction: reaction });
      } else {
        if (thisMessage.reactions[uIndex].reaction == reaction) {
          thisMessage.reactions.splice(uIndex, 1);
        } else {
          thisMessage.reactions[uIndex].reaction = reaction;
        }
      }
      this.countReactions(thisMessage);
      this.updateMessage(thisMessage, callbackSuccess, callbackError);
      var promise = $http.post(`/api/notifications/`, { user: thisMessage._user._id, type: 'messagereaction' });
      promise.then()
      .catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error creating notification.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        console.log('ERROR:', err.data);
      });
    },

    removeMessageFromGroup(messageId, callbackSuccess, callbackError) {
      var mIndex = groupMessages.map(function(msg){ return msg._id; }).indexOf(messageId);
      var thisMessage = groupMessages[mIndex];
      var promise = $http.put(`/api/messages/removeFromGroup/${thisMessage._id}`, thisMessage);
      promise.then(response => {
        try {
          groupMessages.splice(mIndex, 1);
          $timeout(function() {
            common.setQuickNotification('Message Removed.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error removing message.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
        postingMessage = false;
      });
    },

    updateMessage(message, isAdmin, callbackSuccess, callbackError) {
      var updatedMessage = JSON.parse(JSON.stringify(message));
      updatedMessage.msg = updatedMessage.textOnly;
      common.setQuickNotification('Posting message...', 'info');
      var promise = $http.put(`/api/messages/${updatedMessage._id}`, updatedMessage);
      promise.then(response => {
        try {
          $timeout(function() {
            common.setQuickNotification('Message Updated.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error updating message.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
        postingMessage = false;
      });
    },

    updateGlobalSettings(gs, callbackSuccess, callbackError) {
      console.log('Updating Global Settings:', gs);
      common.setQuickNotification('Updating Global Settings...', 'info');
      gs.CheckDigit = 76;
      var promise = $http.post('/api/groups/globals', gs);
      promise.then(response => {
        try {
          globalSettings.postingAllowed = response.data.postingAllowed;
          $timeout(function() {
            common.setQuickNotification('Global Settings Updated.', 'success');
          }, 400);
          safeCb(callbackSuccess)(response.data);
        } catch(e) {
          console.log(e);
        }
      }).catch(err => {
        if(err.status != 401 && err.status != 404) {
          common.setAlert('Error', 'danger', `Error updating global settings.  Please try again!\n\r(Error ${err.status}: ${err.statusText})`, false, true);
        }
        if(callbackError) {
          safeCb(callbackError)(err.data);
        } else if(callbackSuccess) {
          safeCb(callbackSuccess)(err.data);
        }
      });
    }
  };
}

export default angular.module('ffApp.groups', [])
  .service('groups', groupsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/groups/groups.service.js